// Small ISO ⇄ `<input type="datetime-local">` helpers.

const pad = (part) => String(part).padStart(2, "0");

/** ISO-8601 → the value a `datetime-local` input expects (local time). */
export const isoToLocalInput = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

/** A `datetime-local` value → ISO-8601 UTC. */
export const localInputToIso = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toISOString();
};
